module.exports = function _btoa(str) {
  return btoa(str)
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/btoa-lite/btoa-browser.js
 ** module id = 821
 ** module chunks = 0
 **/